import Collapse from "bootstrap/js/dist/collapse.js";
window.Collapse = Collapse;

import './_docready.js';
import './_cursor.js';
import './_layout.js';
import './_nav.js';
import './_blocs.js';
import './_sliders.js';
import './_marquee.js';
import './_forms.js';